import React from "react";

// import SP from "../../images/SP.jpeg";
import introData from "../../data/introData";

const Intro = () => {
  return (
    <section id="intro">
      <h1>{introData.name}</h1>
      <h2>{introData.title}</h2>
      <p>{introData.tagline}</p>
      {/* <img src={SP} alt="SP" /> */}
    </section>
  );
};

export default Intro;
